module.exports = __webpack_public_path__ + "img/logo_gemeente_utrecht.f9cf2edc.svg";